var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getMark(_vm.markType))?_c('v-icon',{attrs:{"color":_vm.color ? _vm.color : _vm.getMark(_vm.markType).color}},[_vm._v(_vm._s(_vm.getMark(_vm.markType).icon))]):_c('v-icon',{attrs:{"color":_vm.color ? _vm.color : _vm.CLEAR_ICON.color}},[_vm._v(_vm._s(_vm.CLEAR_ICON.icon))])
}
var staticRenderFns = []

export { render, staticRenderFns }